import { defineStore } from 'pinia';
import { ServicesBuilder } from '../utils/setup';
import { IReportRequest } from '@posx/core';
import {
  AppReportService,
  IReportCategory,
} from '@posx/core';

export const useReportStore = defineStore('report', {
  state: () => ({
    reports: [] as IReportCategory[],
  }),
  actions: {
    async load() {},
    async syncStandardReports() {
      const service = await ServicesBuilder.getInstance().getService<AppReportService>(
        AppReportService,
      );
      return service.syncStandardReports();
    },
    async printReport(request: IReportRequest) {
      console.log('printReport', request);
      const service = await ServicesBuilder.getInstance().getService<AppReportService>(
        AppReportService,
      );
      return service?.printReport(request);
    },
    async getReports() {
      const service = await ServicesBuilder.getInstance().getService<AppReportService>(
        AppReportService,
      );
      const result = await service?.getDefaultOne();
      this.reports = result?.reports!;
      return this.reports;
    },
  },
});
